import { motion } from "framer-motion";
import { Smartphone, Layers, Zap, Heart } from "lucide-react";

const moments = [
  {
    icon: Smartphone,
    title: "Picked up your phone and forgot why",
    color: "#F58227"
  },
  {
    icon: Layers,
    title: "23 tabs open, none of them helpful",
    color: "#0CBCBF"
  },
  {
    icon: Zap,
    title: "Lost momentum mid-task",
    color: "#F58227"
  },
  {
    icon: Heart,
    title: "Felt guilty after drifting",
    color: "#0CBCBF"
  }
];

export const RecognitionSection = () => {
  return (
    <section 
      id="recognition"
      data-testid="recognition-section"
      className="py-20 md:py-28 px-6 md:px-12 relative"
    >
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <p className="text-sm font-medium uppercase tracking-widest text-[#0CBCBF] mb-4">
            Sound familiar?
          </p>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-[#27272A] mb-4">
            We've all been there
          </h2>
          <p className="text-[#52525B] max-w-md mx-auto">
            These moments aren't flaws. They're just how some minds work.
          </p>
        </motion.div>

        {/* Compact grid - with depth */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-4"
        >
          {moments.map((moment, index) => (
            <div
              key={moment.title}
              data-testid={`recognition-card-${index}`}
              className="bg-white p-5 rounded-2xl text-center group hover:-translate-y-1 transition-transform relative overflow-hidden"
              style={{
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.06), 0 12px 32px rgba(0, 0, 0, 0.05)'
              }}
            >
              {/* Card surface depth */}
              <div 
                className="absolute inset-0 pointer-events-none rounded-2xl"
                style={{ background: 'linear-gradient(180deg, rgba(255,255,255,0.8) 0%, transparent 40%)' }}
              />
              <div 
                className="absolute inset-0 pointer-events-none rounded-2xl"
                style={{ background: 'linear-gradient(0deg, rgba(0,0,0,0.02) 0%, transparent 30%)' }}
              />
              
              <div 
                className="w-10 h-10 rounded-xl flex items-center justify-center mb-3 mx-auto relative z-10"
                style={{ backgroundColor: `${moment.color}15` }}
              >
                <moment.icon size={20} style={{ color: moment.color }} />
              </div>
              <p className="text-sm font-medium text-[#27272A] leading-snug relative z-10">
                {moment.title}
              </p>
            </div>
          ))}
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-8 text-[#A1A1AA]"
        >
          If this is you, you're in good company.
        </motion.p>
      </div>
    </section>
  );
};
